import React, {useEffect, useState} from 'react';
import './services.scss'
import {baseUrl} from "../../../constants/constants";
import Accordion from "./components/accordion/accordion";
import {service} from "./components/data";
import Preview from "../../../assets/cards/education_.webp";
import {Helmet} from "react-helmet-async";

const href =
    typeof window !== "undefined" ? window.location.href : "https://нцпти.рф/";

interface IBanner{
    id: number;
    name: string;
    file_url: string;
}

const Services = () => {
    const [banner, setBanner] = useState<IBanner[]>([]);
    const [mobileBanner, setMobileBanner] = useState<IBanner[]>([]);

    useEffect(() => {
        fetch(`${baseUrl}gallery_images?category_id=19`)
            .then((res) => res.json())
            .then((data: IBanner[]) => {
                const banner = data.filter((item) => item.id === 91);
                setBanner(banner);
            });

        fetch(`${baseUrl}gallery_images?category_id=19`)
            .then((res) => res.json())
            .then((data: IBanner[]) => {
                const bannerMobile = data.filter((el) => el.id === 92);
                setMobileBanner(bannerMobile);
            });
    }, []);

    // @ts-ignore
    // @ts-ignore
    // @ts-ignore
    return (
        <section className={'page-services'}>
            <Helmet>
                <title>Наши услуги | НЦПТИ</title>
                <meta
                    name="description"
                    content="Ознакомьтесь с прайс-листом НЦПТИ, позвоните или напишите, чтобы заказать проведение мероприятия, очного обучения или консультации"
                />
                <meta property="og:title" content="Наши услуги | НЦПТИ" />
                <meta
                    property="og:description"
                    content="Ознакомьтесь с прайс-листом НЦПТИ, позвоните или напишите, чтобы заказать проведение мероприятия, очного обучения или консультации"
                />
                <meta property="og:image" content={Preview} />
                <meta property="og:url" content={href} />
                <meta property="og:type" content="website" />
            </Helmet>
            <h1 className={'main_title'}>Наши услуги</h1>
            {banner &&
                banner.map((i) => (
                    <section className="title-image">
                        <img
                            src={`${baseUrl}${i.file_url}`}
                            alt="Баннер Наши услуги"
                            loading="lazy"
                            className="title-image__img"
                        />
                    </section>
                ))}

            {mobileBanner &&
                mobileBanner.map((e) => (
                    <section className="title-image__mobile">
                        <img
                            src={`${baseUrl}${e.file_url}`}
                            alt="Баннер Наши услуги мобильный"
                            loading="lazy"
                            className="title-image__img-mobile"
                        />
                    </section>
                ))}

            <section className="page">
                <section>
                    {service.map((item) => (
                        <div>
                            <Accordion
                                key={item.id}
                                title={item.title}
                                services={item?.services}
                            />
                        </div>
                    ))}
                </section>
                <section className={'services_info'}>
                    <div className={'services_info_left'}>
                        <h2 className={'services_info_left_title'}>для заказа:</h2>
                        <p  className={'services_info_left_text'}>Писать на почту <a href={'mailto:info@ncpti.ru'} target={"_blank"}>info@ncpti.ru</a><br/>или звонить по номеру <a href={'tel:88632012822'}> +7 (863) 201-28-22</a></p>
                    </div>
                    <div className={'services_info_right'}>
                        <p className={'services_info_right_text'}>*Цены указаны без учёта: стоимости оплаты труда привлечённых, экспертов, транспортных расходов, стоимости печатных материалов (буклетов, брошюр, методических пособий), специального оборудования, кофе-брейка, призов. При необходимости оказания указанных дополнительных услуг (выполнения работ) цена договорная.</p>
                    </div>
                </section>

            </section>
        </section>
    );
};

export default Services;